export interface WishlistItem {
  productId: string;
  nameEn: string;
  nameAr: string;
  slug: string;
  price: number;
  compareAtPrice: number | null;
  imageUrl: string;
  rating: number;
  reviewCount: number;
  inStock: boolean;
  addedAt: string;
}

export const mockWishlist: WishlistItem[] = [
  {
    productId: "prod-1",
    nameEn: "Wireless Noise-Canceling Headphones",
    nameAr: "سماعات لاسلكية عازلة للضوضاء",
    slug: "wireless-noise-canceling-headphones",
    price: 129.99,
    compareAtPrice: 179.99,
    imageUrl: "https://readdy.ai/api/search-image?query=Premium%20wireless%20over-ear%20headphones%20in%20matte%20black%20on%20clean%20warm%20cream%20background%2C%20minimalist%20product%20photography%20with%20soft%20diffused%20studio%20lighting%2C%20front%20view&width=400&height=400&seq=wl-hp&orientation=squarish",
    rating: 4.8,
    reviewCount: 234,
    inStock: true,
    addedAt: "2026-06-18",
  },
  {
    productId: "prod-3",
    nameEn: "Ceramic Aroma Diffuser",
    nameAr: "موزع عطر سيراميك",
    slug: "ceramic-aroma-diffuser",
    price: 45.99,
    compareAtPrice: 59.99,
    imageUrl: "https://readdy.ai/api/search-image?query=Modern%20ceramic%20essential%20oil%20diffuser%20in%20warm%20terracotta%20on%20clean%20cream%20background%2C%20minimalist%20product%20photography%20front%20view%20with%20soft%20lighting&width=400&height=400&seq=wl-diff&orientation=squarish",
    rating: 4.7,
    reviewCount: 156,
    inStock: true,
    addedAt: "2026-06-15",
  },
  {
    productId: "prod-11",
    nameEn: "Linen Throw Blanket",
    nameAr: "بطانية كتان",
    slug: "linen-throw-blanket",
    price: 64.99,
    compareAtPrice: null,
    imageUrl: "https://readdy.ai/api/search-image?query=Luxurious%20linen%20throw%20blanket%20draped%20elegantly%20on%20a%20sofa%20in%20warm%20neutral%20tones%2C%20lifestyle%20product%20photography%20with%20soft%20natural%20lighting&width=400&height=400&seq=wl-blanket&orientation=squarish",
    rating: 4.8,
    reviewCount: 98,
    inStock: true,
    addedAt: "2026-06-10",
  },
];